import MigrationListPage from "./MigrationListPage";
export default function MigrationDispatchPage() {
  return <MigrationListPage stage="for_dispatch" title="For Dispatch" />;
}
